import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useAppStore } from '../../stores';
import { CustomDivider } from '../../../custom_shared/components';
import { WorksheetCard } from '..';
import './WorksheetsList.less';

const WorksheetsList: React.FC = () => {
    const { worksheetsStore, worksheetsSubmissionStore } = useAppStore();

    if (!worksheetsStore.filteredWorksheets.length) {
        return (
            <div className="worksheets-list-empty-container">
                <span className="empty-list-text">No worksheets found</span>
            </div>
        );
    }

    const handleSelectAllChange = (event: CheckboxChangeEvent) => {
        const isAllWorksheetsSelected = event.target.checked;

        worksheetsSubmissionStore.setIsAllWorksheetsSelected(isAllWorksheetsSelected);

        worksheetsSubmissionStore.unlockedWorksheets.forEach(worksheet =>
            worksheet.setIsSelectedForSubmission(isAllWorksheetsSelected)
        );
    };

    return (
        <div className="worksheets-list-container custom-scroll">
            {worksheetsSubmissionStore.selectiveModeEnabled && (
                <>
                    <div className="select-all-checkbox-container">
                        <Checkbox
                            checked={worksheetsSubmissionStore.isAllWorksheetsSelected}
                            onChange={handleSelectAllChange}
                        />
                    </div>
                    <CustomDivider type="horizontal" />
                </>
            )}

            {worksheetsStore.filteredWorksheets.map((worksheet, index, worksheets) => {
                const isLast = index === worksheets.length - 1;
                return (
                    <React.Fragment key={worksheet.id}>
                        <WorksheetCard worksheet={worksheet} />
                        {!isLast && <CustomDivider type="horizontal" />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default observer(WorksheetsList);
